import { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useAdminAuth } from "auth/AdminAuthProvider";
import { adminRequest } from "services/adminApi";

function ChecklistPage() {
  const auth = useAdminAuth();
  const [items, setItems] = useState([]);
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminRequest("/admin/checklist-templates")
      .then((payload) => setItems(payload.draft?.items || payload.draft || []))
      .catch((error) => setMessage(error.message));
  }, []);

  const save = async () => {
    if (saving) return;
    setSaving(true);
    try {
      const payload = await adminRequest("/admin/checklist-templates", {
        method: "PATCH",
        body: JSON.stringify({ items }),
      });
      setItems(payload.draft?.items || items);
      setMessage("تم حفظ القالب كمسودة.");
    } catch (error) {
      setMessage(error.message);
    } finally {
      setSaving(false);
    }
  };

  const publish = async () => {
    if (saving || !window.confirm("هل أنت متأكد من نشر تجهيزات السفر لكل الرحلات الجديدة؟")) return;
    setSaving(true);
    try {
      await adminRequest("/admin/checklist-templates/publish", {
        method: "POST",
        body: JSON.stringify({
          environment: process.env.REACT_APP_ENVIRONMENT || "prod",
          confirm: true,
        }),
      });
      setMessage("تم نشر تجهيزات السفر للرحلات الجديدة.");
    } catch (error) {
      setMessage(error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDTypography variant="h4" fontWeight="bold">
          قوالب تجهيزات السفر
        </MDTypography>
        <MDTypography variant="button" color="text">
          المهام الافتراضية التي تظهر مع كل رحلة جديدة. احفظ التعديلات كمسودة ثم انشرها عندما تصبح
          جاهزة.
        </MDTypography>
        {message && <Alert sx={{ my: 2 }}>{message}</Alert>}
        <MDBox bgColor="white" borderRadius="xl" shadow="sm" p={3} mt={3}>
          {items.map((item, index) => (
            <MDBox key={item.taskId || index} display="flex" gap={1} mb={2}>
              <TextField
                fullWidth
                label={`المهمة ${index + 1}`}
                value={item.title || ""}
                onChange={(event) =>
                  setItems((current) =>
                    current.map((entry, itemIndex) =>
                      itemIndex === index ? { ...entry, title: event.target.value } : entry
                    )
                  )
                }
              />
              <Button
                color="error"
                onClick={() =>
                  setItems((current) => current.filter((_, itemIndex) => itemIndex !== index))
                }
              >
                حذف
              </Button>
            </MDBox>
          ))}
          <MDBox display="flex" gap={1}>
            <Button
              variant="outlined"
              onClick={() =>
                setItems((current) => [
                  ...current,
                  {
                    taskId: `task_${Date.now()}`,
                    title: "",
                    category: "before_trip",
                    isRequired: true,
                    weight: 1,
                  },
                ])
              }
            >
              <Icon sx={{ ml: 0.5 }}>add</Icon>
              إضافة مهمة
            </Button>
            <Button variant="contained" color="success" disabled={saving} onClick={save}>
              {saving ? "جارٍ الحفظ..." : "حفظ كمسودة"}
            </Button>
            {auth.canPublish && (
              <Button variant="contained" disabled={saving} onClick={publish}>
                نشر للمسافرين
              </Button>
            )}
          </MDBox>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default ChecklistPage;
